export const MIDDLE_INITIAL_INPUT_MAX_LEGTH = 1;
